import WebPushContext from './WebPushContext';

const WebPushConsumer = WebPushContext.Consumer;

export default WebPushConsumer;
